export default {
    p11Mask: ['maskpii','sessioncamexclude', 'sessioncamhidetext']
}
